import { gql } from "apollo-angular";
// platzierungen_kennzahlen_filialLagerBestand
export const gql_weiterePlatzierungen = gql`
query weiterePlatzierungen($skip: Int, $take: Int, $filter: SortimentPlatzierungFilterInput)
{ sortimentPlatzierung( skip: $skip take: $take where: $filter order: [] ) { totalCount, pageInfo { hasNextPage hasPreviousPage }

 items {
  sortiment {id name}
  klammer { name }
  platzierungen {
     id
     changed
     moebel { id name }
     modulNumber  }}
}}


  `
